import { Container } from "bionline-components-library"
import SideBar from "../Sidebar"
import { motion, AnimatePresence } from "framer-motion"
import { useLocation } from "react-router-dom"

import "./Layout.css"

interface ILayout {
  children: JSX.Element
  isLoggedIn: boolean
}

const Layout = ({ children, isLoggedIn }: ILayout) => {
  const location = useLocation()
  const isChatRoute = location.pathname.startsWith("/audiences/chat")

  return (
    <>
      <div className={isLoggedIn ? "container-shell" : ""}>
        {isLoggedIn && <SideBar />}
        <AnimatePresence mode="wait">
          <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 20 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.15 }}
            className={
              isLoggedIn
                ? `container-shell-children ${
                    isChatRoute ? "container-shell-children--full" : ""
                  }`
                : ""
            }
          >
            {isLoggedIn ? (
              isChatRoute ? (
                <div className="container-children container-children--full">
                  {children}
                </div>
              ) : (
                <Container className="container-children">{children}</Container>
              )
            ) : (
              children
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  )
}

export default Layout
